import { PairedSalesStudy, StudiesPair } from '@aloft/toolkit-shared';

import { Table } from '../../../components/pdf-export/Table/Table.js';
import { StudyTableHeader } from './StudyTableHeader.js';
import { StudyTableRow } from './StudyTableRow.js';

function makeKey(pair: StudiesPair, index: number): string {
  return (
    (pair.p1.toolkitRecordID ?? index.toString()) + (pair.p2.toolkitRecordID ?? index.toString())
  );
}

type Props = {
  study: PairedSalesStudy;
};

export function StudyTable({ study }: Props) {
  return (
    <Table>
      <StudyTableHeader term={study.input.analysisFeature} />
      {study.body.selectedPairs.map((pair, index) => (
        <StudyTableRow
          key={makeKey(pair, index)}
          index={index}
          pair={pair}
          term={study.input.analysisFeature}
          reconciledValue={study.body.reconciledValue}
        />
      ))}
    </Table>
  );
}
